export type ColorThemeId = "default" | "github";

export interface ColorTheme {
  id: ColorThemeId;
  label: string;
  description: string;
}

export const colorThemeStorageKey = "chew:color-theme";
export const defaultColorTheme: ColorThemeId = "default";

export const colorThemes: ColorTheme[] = [
  { id: "default", label: "CHEW", description: "The default palette" },
  { id: "github", label: "GitHub", description: "GitHub review colors" },
];

function isColorThemeId(value: unknown): value is ColorThemeId {
  return colorThemes.some((theme) => theme.id === value);
}

export function storedColorTheme(
  value: string | null = localStorage.getItem(colorThemeStorageKey),
): ColorThemeId {
  return isColorThemeId(value) ? value : defaultColorTheme;
}

export function applyColorTheme(theme: ColorThemeId): void {
  if (theme === defaultColorTheme) {
    delete document.documentElement.dataset.colorTheme;
  } else {
    document.documentElement.dataset.colorTheme = theme;
  }
}
